import { __decorate, __metadata } from "tslib";
import { SerializableMember, SerializableObject } from '@openhps/core';
import { tree } from '../../terms';
import { RDFSerializer, SerializableNamedNode, SerializableThing } from '@openhps/rdf';
let Relation = class Relation {
    constructor(value, node) {
        this.value = value;
        this.node = node;
    }
    setPath(path) {
        this.path = new SerializableNamedNode(path);
        return this;
    }
};
__decorate([
    SerializableMember({
        rdf: {
            predicate: tree.node,
            serializer: false,
            deserializer: (node) => {
                return new SerializableThing(node.value);
            },
        },
    }),
    __metadata("design:type", SerializableThing)
], Relation.prototype, "node", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicate: tree.path,
        },
    }),
    __metadata("design:type", SerializableNamedNode)
], Relation.prototype, "path", void 0);
__decorate([
    SerializableMember({
        constructor: Object,
        rdf: {
            predicate: tree.value,
            serializer: (value) => {
                return RDFSerializer.serialize(value);
            },
            deserializer: (thing) => {
                return RDFSerializer.deserialize(thing);
            },
        },
    }),
    __metadata("design:type", Object)
], Relation.prototype, "value", void 0);
Relation = __decorate([
    SerializableObject({
        rdf: {
            type: tree.Relation,
            serializer: (object, baseUri) => {
                if (!object.value) {
                    return {};
                }
                // Serialize the value to a string that can be stored in RDF as URI
                switch (object.value.constructor) {
                    case Date:
                        // Convert the date to a string that can be used inside a URI
                        // timestamp as epoch
                        return {
                            termType: 'NamedNode',
                            value: baseUri + object.value.getTime().toString(),
                        };
                    default:
                        // URI encode the value assuming its a string
                        return {
                            termType: 'NamedNode',
                            value: baseUri + encodeURIComponent(object.value.toString()),
                        };
                }
            },
        },
    }),
    __metadata("design:paramtypes", [Object, Function])
], Relation);
export { Relation };
let GreaterThanOrEqualToRelation = class GreaterThanOrEqualToRelation extends Relation {
    test(value) {
        return value >= this.value;
    }
};
GreaterThanOrEqualToRelation = __decorate([
    SerializableObject({
        rdf: {
            type: tree.GreaterThanOrEqualToRelation,
        },
    })
], GreaterThanOrEqualToRelation);
export { GreaterThanOrEqualToRelation };
let GreaterThanRelation = class GreaterThanRelation extends Relation {
    test(value) {
        return value > this.value;
    }
};
GreaterThanRelation = __decorate([
    SerializableObject({
        rdf: {
            type: tree.GreaterThanRelation,
        },
    })
], GreaterThanRelation);
export { GreaterThanRelation };
let LessThanOrEqualToRelation = class LessThanOrEqualToRelation extends Relation {
    test(value) {
        return value <= this.value;
    }
};
LessThanOrEqualToRelation = __decorate([
    SerializableObject({
        rdf: {
            type: tree.LessThanOrEqualToRelation,
        },
    })
], LessThanOrEqualToRelation);
export { LessThanOrEqualToRelation };
let LessThanRelation = class LessThanRelation extends Relation {
    test(value) {
        return value < this.value;
    }
};
LessThanRelation = __decorate([
    SerializableObject({
        rdf: {
            type: tree.LessThanRelation,
        },
    })
], LessThanRelation);
export { LessThanRelation };
//# sourceMappingURL=Relation.js.map